// extracted by mini-css-extract-plugin
export var defaultWrapper = "_l2-3";
export var downloadButton = "_l2-4";
export var fileContainer = "_l2-9 _l2-7";
export var fileContainerBase = "_l2-7";
export var fileContainerFixedHeight = "_l2-8 _l2-7";
export var fileInfo = "_l2-5";
export var fileInfoWidthRestricted = "_l2-6";
export var fileType = "_l2-1";
export var fileTypeName = "_l2-2";
export var image = "_l2-0";
export var link = "_l2-b";
export var overflowEllipsis = "_l2-a";